import React, { useContext, useEffect, useState } from 'react';
import { ThemeContext } from '../App';

export default function CadastroTalhao({ onCriar, talhaoEdicao, onSalvarEdicao, propriedadeSelecionada, salvando = false }) {
  const { darkMode } = useContext(ThemeContext);
  const [nome, setNome] = useState('');
  const [area, setArea] = useState('');
  const [observacoes, setObservacoes] = useState('');

  useEffect(() => {
    setNome(talhaoEdicao?.nome || '');
    setArea(talhaoEdicao?.area || '');
    setObservacoes(talhaoEdicao?.observacoes || '');
  }, [talhaoEdicao]);

  const handleSubmit = event => {
    event.preventDefault();
    if (salvando) return;
    if (!nome.trim()) {
      alert('Informe o nome do talhão.');
      return;
    }

    const talhao = {
      nome: nome.trim(),
      observacoes: observacoes.trim(),
      propriedade_id: propriedadeSelecionada?.id,
    };
    if (talhaoEdicao) onSalvarEdicao({ id: talhaoEdicao.id, ...talhao });
    else onCriar(talhao);
  };

  const inputStyle = {
    width: '100%',
    padding: 11,
    borderRadius: 9,
    border: `1px solid ${darkMode ? '#555' : '#b0c4de'}`,
    fontSize: 16,
    boxSizing: 'border-box',
    background: darkMode ? '#2a2a2a' : '#fff',
    color: darkMode ? '#e0e0e0' : '#333',
  };

  return (
    <div className="props-plot-form-wrap" style={{ width: '100%', display: 'flex', justifyContent: 'center', minHeight: 420, marginBottom: 24 }}>
      <div className="props-plot-form-panel" style={{
        background: darkMode ? '#232526' : '#fff', borderRadius: 16,
        boxShadow: darkMode ? '0 2px 12px #0006' : '0 2px 12px #0001',
        padding: window.innerWidth < 768 ? '24px 16px' : '32px 24px',
        maxWidth: 480, width: '100%', boxSizing: 'border-box',
      }}>
        <h3 className="props-form-title" style={{ color: darkMode ? '#90caf9' : '#1976d2', margin: '0 0 8px', fontWeight: 800, fontSize: 20, textAlign: 'center' }}>
          {talhaoEdicao ? 'Editar área do talhão' : 'Cadastrar área permanente'}
        </h3>
        <p style={{ margin: '0 0 20px', textAlign: 'center', color: darkMode ? '#b8c1cc' : '#62758a', fontSize: 13, lineHeight: 1.45 }}>
          O talhão representa uma área física permanente da propriedade. Cultura, plantio e colheita são registrados separadamente dentro dele.
        </p>

        <form className="props-property-form props-plot-form" onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 13 }}>
          <label style={{ fontSize: 13, fontWeight: 700, color: darkMode ? '#d5e7f7' : '#274b69' }}>
            Nome do talhão
            <input placeholder="Ex.: Pivô 01, Pasto Norte" value={nome} onChange={event => setNome(event.target.value)} required maxLength="100" style={{ ...inputStyle, marginTop: 5 }} />
          </label>
          <div style={{ padding: 12, borderRadius: 10, background: darkMode ? '#172536' : '#eef7fb', color: darkMode ? '#b9d8ec' : '#365d74', fontSize: 13 }}>
            <strong>Área georreferenciada: {area ? `${area} ha` : 'não calculada'}</strong><br />
            Área, posição e desenho são alterados somente pela Central de Operações para preservar o perímetro medido.
          </div>

          {!talhaoEdicao?._operationalPhysical && (
          <label style={{ fontSize: 13, fontWeight: 700, color: darkMode ? '#d5e7f7' : '#274b69' }}>
            Observações da área <small style={{ fontWeight: 400 }}>(opcional)</small>
            <textarea placeholder="Acesso, relevo, identificação interna..." value={observacoes} onChange={event => setObservacoes(event.target.value)} rows="3" maxLength="500" style={{ ...inputStyle, marginTop: 5, resize: 'vertical' }} />
          </label>
          )}

          <button className="props-form-submit" type="submit" disabled={salvando} style={{ width: '100%', background: '#159a83', color: '#fff', border: 'none', borderRadius: 10, padding: '0.8rem 0', fontWeight: 800, fontSize: 16, cursor: salvando ? 'not-allowed' : 'pointer', opacity: salvando ? 0.7 : 1, marginTop: 4 }}>
            {salvando ? 'Salvando...' : talhaoEdicao ? 'Salvar área do talhão' : 'Cadastrar talhão'}
          </button>
        </form>
      </div>
    </div>
  );
}
